import { render } from "./HeroiconsOutlineViewGridAdd.vue?vue&type=template&id=532aa443"
const script = {}

import exportComponent from "/Users/administrator/Sites/HengFuTong/extends/nova/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"HeroiconsOutlineViewGridAdd.vue"]])

export default __exports__